// extracted by mini-css-extract-plugin
export default {"container":"WV-z","modal":"XV-z","dimensions":"YV-z","brandName":"ZV-z","productName":"_V-z","recipientEmail":"aW-z","recommendedFit":"bW-z","hiddenField":"cW-z"};